<div class="d-flex flex-column" *ngSubscribe="tabConfig$ as tabConfig">
    <section class="widget-section" [ngClass]="getTabConfigClassesForComponentId('app-my-app-tiles', 1, tabConfig)" id="app-my-app-tiles">
        <div class="container pt-4 pb-4 pt-lg-6 pb-lg-6">
            <app-my-app-tiles appMarkComponentVisited></app-my-app-tiles>
        </div>
        <div class="container pt-4 pb-4 pt-lg-6 pb-lg-6" #smartLinksContainer>
            <app-smart-links [appHideParentIfEmpty]="smartLinksContainer" appMarkComponentVisited data-notsortable="true"></app-smart-links>
        </div>
    </section>
    <section class="widget-section" [ngClass]="getTabConfigClassesForComponentId('app-power-bi', 2, tabConfig)" id="app-power-bi">
      <div class="container pt-4 pb-4 pt-lg-6 pb-lg-6" #powerBIFramesContainer>
        <app-power-bi appMarkComponentVisited [appHideParentIfEmpty]="powerBIFramesContainer"></app-power-bi>
      </div>
    </section>
    <section class="widget-section" [ngClass]="getTabConfigClassesForComponentId('app-my-day', 3, tabConfig)" id="app-my-day">
        <div class="container pt-4 pb-4 pt-lg-6 pb-lg-6">
            <app-my-day></app-my-day>
        </div>
    </section>
    <section class="widget-section" [ngClass]="getTabConfigClassesForComponentId('app-my-documents', 4, tabConfig)" id="app-my-documents">
        <div class="container pt-4 pb-4 pt-lg-6 pb-lg-6">
            <app-my-documents></app-my-documents>
        </div>
    </section>
    <ng-container *ngIf="areAllComponentsTurnedOff(4, tabConfig)">
        <section class="widget-section">
            <div class="container pt-4 pb-4 pt-lg-6 pb-lg-6">
                <p class="text-muted" i18n="all components off@@all-components-off">All components are turned off. Go to <a routerLink="/settings">settings</a> to turn them on.</p>
            </div>
        </section>
    </ng-container>
</div>
